import { Duration } from "luxon";

import { ID_DEFAULT_GROUP } from "@/modules/auth/constants";

import { DwellingCostResponse } from "../types";

export const colorsMap = {
  new: {
    label: "Neuf",
    color: "hsl(220, 92%, 63%)",
  },
  good: {
    label: "Bon état",
    color: "hsl(171, 84%, 41%)",
  },
  average: {
    label: "État moyen",
    color: "hsl(24, 100%, 58%)",
  },
  poor: {
    label: "Dégradé",
    color: "hsl(5, 86%, 54%)",
  },
  oof: {
    label: "Hors d'usage",
    color: "hsl(0, 100%, 50%)",
  },
};

/** Formats the data for the horizontal chart */
export function formatDataForHorizontalChart(
  report: DwellingCostResponse["dwelling"]["totalCondition"]
) {
  return (
    [
      {
        key: "new",
        percentage: report.new.percentage,
      },
      {
        key: "good",
        percentage: report.good.percentage,
      },
      {
        key: "average",
        percentage: report.average.percentage,
      },
      {
        key: "poor",
        percentage: report.poor.percentage,
      },
      {
        key: "oof",
        percentage: report.oof.percentage,
      },
    ] as const
  ).filter((condition) => condition.percentage !== 0) satisfies {
    key: "new" | "good" | "average" | "poor" | "oof";
    percentage: number;
  }[];
}

interface OccupationPeriod {
  years: number;
  months: number;
  days: number;
}

export function resolveOccupancyDuration(occupancyDuration: OccupationPeriod) {
  const duration = Duration.fromObject(occupancyDuration);

  const years = duration.years || 0;
  const months = duration.months || 0;
  const days = duration.days || 0;
  let durationString = "";
  if (years > 0) {
    durationString += `${years} an${years > 1 ? "s" : ""}`;
  }
  if (years > 0 && months > 0) {
    durationString += " et ";
  }
  if (months > 0) {
    durationString += `${months} mois`;
  }
  if (months === 0 && years === 0) {
    durationString = `${days} jour${days > 1 ? "s" : ""}`;
  }
  return durationString;
}

export function extractLocationDataFromSubmit(locationData: string) {
  const values = locationData.split("_");
  return {
    roomId: values[0],
    unitIndex: values[1],
    unitName: values[2],
    field: values[3],
  };
}

export const isWithDefaultGroup = (userData: any): boolean => {
  try {
    const rights = userData.rights;

    const hasGroupGet = rights.some((right: any) =>
      right.agencies?.some((agency: any) =>
        agency.teams?.some((team: any) => team.rights?.includes("GROUP_GET"))
      )
    );

    if (hasGroupGet) {
      return true;
    }

    const hasMatchingGroupId = rights.some(
      (right: any) => right.groupId === ID_DEFAULT_GROUP
    );

    return hasMatchingGroupId;
  } catch (error) {
    console.error("Error in isWithDefaultGroup:", error);
    return false;
  }
};
